import { DynamoDBClient } from '@aws-sdk/client-dynamodb';
import { DynamoDBDocumentClient, GetCommand } from '@aws-sdk/lib-dynamodb';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';

const contentAccessTable = import.meta.env.VITE_CONTENT_ACCESS_TABLE;
const awsRegion = import.meta.env.VITE_DYNAMO_DB_REGION;
const cognitoAwsRegion = import.meta.env.VITE_COGNITO_REGION;
const awsCognitoIdentityPoolId = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;

export const docClient = DynamoDBDocumentClient.from(new DynamoDBClient({
  region: awsRegion,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: cognitoAwsRegion },
    identityPoolId: awsCognitoIdentityPoolId
  })
}));

export async function getContentCountsForUser(userUUID) {
  const now = (new Date()).toISOString()
  const yearMonth = now.split('-').slice(0, 2).join('-')
  const cmd = new GetCommand({
    TableName: contentAccessTable,
    Key: {
      user_uuid: userUUID,
      year_month: yearMonth
    }
  })

  try {
    const resp =  await docClient.send(cmd);
    return resp.Item || null
  } catch (e) {
    console.error(e)
    throw new Error(e);
  }

}